import moment from 'moment'

export function getInitials(string) {
    var names = string.split(' ');
    var initials = names[0].substring(0, 1).toUpperCase();

    if (names.length > 1) {
        initials += names[names.length - 1].substring(0, 1).toUpperCase();
    }
    return initials;
}

export function formatPhoneNumber(phoneNumberString) {
    var cleaned = ('' + phoneNumberString).replace(/\D/g, '')
    var match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/)
    if (match) {
        return '(' + match[1] + ') ' + match[2] + '-' + match[3]
    }
    return null
}

export function formatDate(date, format = 'YYYY-MM-DD h:mm:ss') {
    const newDate = moment(date);
    return newDate.format(format);
}
